import { ROUTES } from "./routes/routes";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ProjectProgressPage from "./pages/ProjectProgressPage";
import Header from "./components/header/Header";
import LoginPage from "./pages/LoginPage";
import RequireAuth from "./components/requireAuth/RequireAuth";
import InitializeAuth from "./components/initializeAuth/InitializeAuth";
import UserProjectAccessPage from "./pages/UserProjectAccessPage";
import RedirectPage from "./pages/RedirectPage";
import EmailConfirmationPage from "./pages/EmailConfirmationPage";
import EmailConfirmedPage from "./pages/EmailConfirmedPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import SyncDashboardPage from "./pages/SyncDashboardPage";
import HoursDashboardPage from "./pages/HoursDashboardPage";
import MilestoneHealthReportPage from "./pages/MilestoneHealthReportPage";
import MilestoneManagementPage from "./pages/MilestoneManagementPage";

const DEPRECATION_EXPIRY = new Date("2026-04-19T00:00:00Z");

function DeprecationBanner() {
  if (
    window.location.hostname !== "ebn1.cquelle.dev" ||
    new Date() > DEPRECATION_EXPIRY
  ) {
    return null;
  }

  return (
    <div
      style={{
        backgroundColor: "#fff3cd",
        color: "#856404",
        padding: "12px 24px",
        textAlign: "center",
        fontSize: "14px",
        fontWeight: 500,
        borderBottom: "1px solid #ffc107",
      }}
    >
      This domain (<strong>ebn1.cquelle.dev</strong>) is deprecated. Please switch to{" "}
      <a
        href="https://teamray.cquelle.dev"
        style={{ color: "#856404", fontWeight: 700 }}
      >
        https://teamray.cquelle.dev
      </a>
    </div>
  );
}

function App() {
  return (
    <InitializeAuth>
      <BrowserRouter>
        <DeprecationBanner />
        <Header />
        <Routes>
          <Route path={ROUTES.LOGIN} element={<LoginPage />} />
          <Route path={ROUTES.EMAIL_CONFIRMATION} element={<EmailConfirmationPage />} />
          <Route path={ROUTES.EMAIL_CONFIRMED} element={<EmailConfirmedPage />} />
          <Route path={ROUTES.FORGOT_PASSWORD} element={<ForgotPasswordPage />} />
          <Route path={ROUTES.RESET_PASSWORD} element={<ResetPasswordPage />} />

          <Route
            path={ROUTES.HOME}
            element={
              <RequireAuth>
                <ProjectProgressPage />
              </RequireAuth>
            }
          />
          <Route
            path={ROUTES.HOME_WITH_PARAMS}
            element={
              <RequireAuth>
                <ProjectProgressPage />
              </RequireAuth>
            }
          />
          <Route
            path={ROUTES.AUTHORIZE_REDIRECT}
            element={<RedirectPage />}
          />
          <Route
            path={ROUTES.USER_PROJECT_ACCESSES}
            element={
              <RequireAuth roles={"Admin"}>
                <UserProjectAccessPage />
              </RequireAuth>
            }
          />
          <Route
            path={ROUTES.HOURS_DASHBOARD}
            element={
              <RequireAuth>
                <HoursDashboardPage />
              </RequireAuth>
            }
          />
          <Route
            path={ROUTES.SYNC_DASHBOARD}
            element={
              <RequireAuth roles={"Admin"}>
                <SyncDashboardPage />
              </RequireAuth>
            }
          />
          <Route
            path={ROUTES.MILESTONE_HEALTH_REPORT}
            element={
              <RequireAuth roles={"Admin"}>
                <MilestoneHealthReportPage />
              </RequireAuth>
            }
          />
          <Route
            path={ROUTES.MANAGE_MILESTONES}
            element={
              <RequireAuth roles={"Admin"}>
                <MilestoneManagementPage />
              </RequireAuth>
            }
          />
        </Routes>
      </BrowserRouter>
    </InitializeAuth>
  );
}

export default App;
